import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Close, CloseSmall} from '@wix/wix-ui-icons-common/on-stage'
import {IconButton, IconButtonThemes} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {classes} from './close-button.st.css'
import {CloseButtonProps} from './interfaces'

export const CloseButton = ({closeButtonAsButton, closeModal, className, small}: CloseButtonProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()

  return (
    <IconButton
      aria-label={t('a11y.close')}
      theme={closeButtonAsButton ? IconButtonThemes.Box : IconButtonThemes.None}
      data-hook={DH.CLOSE_BUTTON}
      className={classNames(classes.closeButtonX, className, {
        [classes.asButton]: closeButtonAsButton,
        [classes.desktop]: !isMobile,
      })}
      onClick={() => closeModal()}
      tabIndex={0}
      icon={small ? <CloseSmall /> : <Close />}
    />
  )
}
